import apiConfig, { getRequestHeaders } from './base'

const baseApiURL = apiConfig.baseApiURL
const { axiosInstance } = apiConfig

/**
 * RS-006: Get current user's CASL abilities
 */
export const getMe = async () => {

    let result = {
        success: false
    }

    const requestHeaders = getRequestHeaders()

    try {
        const { data } = await axiosInstance.get(`${baseApiURL}/admin/auth/me`, requestHeaders)
        result = {
            success: true,
            ...data
        }
    }
    catch (e) {
        result.message = e.message
    }

    return result
}
